import { UserSystemGroup, UserSystemGroupStrings } from 'store/storeTypes';

// The API accepts system group types as strings in requests (None/DTG/DTF/Apollo) but
// serializes them as their underlying numeric enum value in responses (default .NET int
// serialization). Values below are inferred from a [Flags]-style bit pattern matching the
// Swagger enum order (None, DTG, DTF, Apollo) and the numbers actually observed in
// responses (1, 2, 4) — worth confirming with the backend, but the best fit we have.
export const SYSTEM_GROUP_TYPE_VALUES: Partial<Record<UserSystemGroupStrings, number>> = {
  [UserSystemGroup.DTG]: 1,
  [UserSystemGroup.DTF]: 2,
  [UserSystemGroup.Apollo]: 4,
};

export const systemGroupTypeFromApi = (value: number): UserSystemGroupStrings | null => {
  const entry = Object.entries(SYSTEM_GROUP_TYPE_VALUES).find(([, v]) => v === value);
  return entry ? (entry[0] as UserSystemGroupStrings) : null;
};

// Falls back to the raw number as a label when it doesn't match a known type (e.g. the
// matrix table can still render a column header instead of silently dropping data).
export const systemGroupTypeLabelFromApi = (value: number): string =>
  systemGroupTypeFromApi(value) ?? String(value);

// .NET System.DayOfWeek: Sunday=0 .. Saturday=6.
export const DAY_OF_WEEK_NAMES = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
